export function undefinedOrNull(val) {
    return typeof val === 'undefined' || val === null;
}

export function hasProperty(element, propertyName) {
    return Object.prototype.hasOwnProperty.call(element, propertyName);
}

export function hasPropertyDeep(element, propertyNames) {
    const names = propertyNames.split('.');
    let thisObject = element;
    
    for (let i = 0; i < names.length; i++) {
        const name = names[i];
        if (undefinedOrNull(thisObject)) {
            return false;
        }
        if (hasProperty(thisObject, name)) {
            if (i === names.length - 1) {
                return true;
            }
            thisObject = thisObject[name];
        } else {
            return false;
        }
    }
}
